import React from "react";
import { Box, Card, CardContent, Typography } from "@mui/material";
import Groups2Icon from "@mui/icons-material/Groups2";
import DesktopWindowsIcon from "@mui/icons-material/DesktopWindows";
import EventSeatIcon from "@mui/icons-material/EventSeat";
import AirlineSeatReclineNormalIcon from "@mui/icons-material/AirlineSeatReclineNormal";

const cardStyle = {
  height: "100%",
  minWidth: 0,
  border: "1px solid rgba(64,81,138,0.12)",
  borderRadius: 3,
  background: "linear-gradient(135deg,#ffffff 0%,#f8f9fa 100%)",
  boxShadow: "0 10px 28px rgba(31,45,84,0.12)",
  transition: "box-shadow 0.2s ease, transform 0.2s ease",

  "&:hover": {
    boxShadow: "0 12px 32px rgba(0,0,0,0.18)",
    transform: "translateY(-2px)",
  },
};

export default function WorkstationKpiCards({
  totalWorkspaces = 0,
  totalWorkstations = 0,
  occupiedWorkstations = 0,
  emptyWorkstations = 0,
}) {
  const cards = [
    {
      title: "Total Workspaces",
      value: totalWorkspaces,
      subtitle: "Active workspaces",
      icon: <Groups2Icon />,
      iconBackground: "#E8F0FE",
      iconColor: "#2563EB",
    },
    {
      title: "Total Workstations",
      value: totalWorkstations,
      subtitle: "Across all workspaces",
      icon: <DesktopWindowsIcon />,
      iconBackground: "#E8F0FE",
      iconColor: "#2563EB",
    },
    {
      title: "Occupied",
      value: occupiedWorkstations,
      subtitle: "Currently occupied",
      icon: <AirlineSeatReclineNormalIcon />,
      iconBackground: "#DCFCE7",
      iconColor: "#16A34A",
    },
    {
      title: "Empty",
      value: emptyWorkstations,
      subtitle: "Currently available",
      icon: <EventSeatIcon />,
      iconBackground: "#FEE2E2",
      iconColor: "#DC2626",
    },
  ];

  return (
    <Box
      sx={{
        width: "100%",
        display: "grid",
        gridTemplateColumns: {
          xs: "1fr",
          sm: "repeat(2, minmax(0, 1fr))",
          lg: "repeat(4, minmax(0, 1fr))",
        },
        gap: 2,
      }}
    >
      {cards.map((card) => (
        <Card key={card.title} sx={cardStyle}>
          <CardContent
            sx={{
              p: 2,
              "&:last-child": { pb: 2 },
            }}
          >
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                gap: 1.5,
                minWidth: 0,
              }}
            >
              <Box sx={{ minWidth: 0 }}>
                <Typography
                  sx={{
                    fontSize: 14,
                    fontWeight: 500,
                    color: "#64748B",
                    mb: 1,
                  }}
                >
                  {card.title}
                </Typography>

                <Typography
                  sx={{
                    fontSize: { xs: 28, sm: 30, md: 32 },
                    fontWeight: 700,
                    lineHeight: 1.1,
                    color: "#1E293B",
                    overflowWrap: "anywhere",
                  }}
                >
                  {card.value}
                </Typography>

                <Typography
                  sx={{
                    fontSize: 12,
                    color: "#94A3B8",
                    mt: 1,
                  }}
                >
                  {card.subtitle}
                </Typography>
              </Box>

              <Box
                sx={{
                  width: 44,
                  height: 44,
                  minWidth: 44,
                  borderRadius: 2,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  backgroundColor: card.iconBackground,
                  color: card.iconColor,
                  "& svg": { fontSize: 24 },
                }}
              >
                {card.icon}
              </Box>
            </Box>
          </CardContent>
        </Card>
      ))}
    </Box>
  );
}